import { ChangeEvent, FC } from 'react'
import { Flex } from '@chakra-ui/react'

import { DynamicInputByType, FormItem } from 'components'

// import { CheckCircle } from 'components/icons'

type Props = {
  values: any
  setValues: any
  metadata: any
}

const MetadatasForm: FC<Props> = ({ values, setValues, metadata }) => {
  function onChangeMetadataValuesInputs(event: ChangeEvent<HTMLInputElement>, number: number) {
    setValues({ ...values, [`info_${number}`]: event.target.value })
  }

  return (
    <Flex direction="column" gap={4} width="100%">
      {metadata.name &&
        [1, 2, 3, 4, 5, 6, 7].map((number) => {
          const label = metadata[`info_${number}_label`]
          const type = metadata[`info_${number}_data_type`]
          const inputId = `field_${number}`

          const filterValue = values[`info_${number}`]

          if (!label) return null

          return (
            <FormItem key={number} label={label} htmlFor={inputId} mb={0}>
              <DynamicInputByType
                id={inputId}
                type={type}
                value={filterValue}
                onChange={(event) => onChangeMetadataValuesInputs(event, number)}
              />
            </FormItem>
          )
        })}
    </Flex>
  )
}

export default MetadatasForm
